
<div v-if="hasCoupons" class="discountBanner">
  <div :class="{discountProgress: true, active: isOpen}"
       @click="toggleOpen()"
       @mouseover="onHover(true)"
       @mouseleave="onHover(false)"
  >
    <svg class="discount" :style="{'left': `${discountPercentage}%`}" viewBox="0 0 14.96 28.67">
      <path class="accent--text background"
            d="M.9,0H14.06a.9.9,0,0,1,.9.9V19.46a3.19,3.19,0,0,1-.69,2L9.1,27.89a2.07,2.07,0,0,1-3.24,0L.69,21.43a3.13,3.13,0,0,1-.69-2V.9A.9.9,0,0,1,.9,0Z"/>
      <path class="foreground"
            d="M9.86,14.82A1.83,1.83,0,1,1,11.69,13,1.83,1.83,0,0,1,9.86,14.82Zm0-2.72a.9.9,0,1,0,.89.89A.89.89,0,0,0,9.86,12.1Z"/>
      <path class="foreground"
            d="M5.1,10.06A1.83,1.83,0,1,1,6.93,8.23,1.83,1.83,0,0,1,5.1,10.06Zm0-2.72A.9.9,0,1,0,6,8.23.89.89,0,0,0,5.1,7.34Z"/>
      <path class="foreground"
            d="M3.74,14.82a.47.47,0,0,1-.33-.8l7.48-7.48a.47.47,0,0,1,.66.66L4.07,14.68A.47.47,0,0,1,3.74,14.82Z"/>
    </svg>
    <div class="meter">
      <span class="secondary progress" :style="{width: `${discountPercentage}%`}"></span>
      <span v-for="coupon in coupons" :class="{marker: true, accent: couponActive(coupon)}"
            :style="{'left': calcMeterLeft(percentageOf(coupon.minimumValue))}"></span>
      <div class="secondary tooltip">
        <div v-if="expiryDate" class="couponContainer">
          <svg class="coupon" viewBox="0 0 256.3 73.19">
            <path class="secondary--text inheritFill"
                  d="M249.17,36.59a6.15,6.15,0,0,0,6.15,6.15,5.33,5.33,0,0,0,1-.09V73.19H0V42.74a6.15,6.15,0,0,0,6.15-6.15A6.15,6.15,0,0,0,0,30.45V0H256.3V30.54a5.33,5.33,0,0,0-1-.09A6.15,6.15,0,0,0,249.17,36.59Z"/>
            <path class="accent--text inheritFill"
                  d="M98.37,59.32a.5.5,0,0,1-.5-.5V14.22a.5.5,0,1,1,1,0v44.6A.5.5,0,0,1,98.37,59.32Z"/>
            <circle class="foreground" cx="54.26" cy="36.59" r="23.11"/>
            <path class="secondary--text inheritFill"
                  d="M60.84,48.21a5,5,0,1,1,5-5A5,5,0,0,1,60.84,48.21Zm0-7.51a2.47,2.47,0,1,0,2.46,2.47A2.48,2.48,0,0,0,60.84,40.7Z"/>
            <path class="secondary--text inheritFill"
                  d="M47.69,35.07A5.05,5.05,0,1,1,52.74,30,5.06,5.06,0,0,1,47.69,35.07Zm0-7.51A2.47,2.47,0,1,0,50.16,30,2.46,2.46,0,0,0,47.69,27.56Z"/>
            <path class="secondary--text inheritFill"
                  d="M43.93,48.21a1.28,1.28,0,0,1-.91-.37A1.3,1.3,0,0,1,43,46L63.68,25.35a1.29,1.29,0,0,1,1.83,1.83L44.85,47.84A1.28,1.28,0,0,1,43.93,48.21Z"/>
          </svg>
          <p class="validUntil">{{ $t("COUPON_VALID_UNTIL") }}</p>
          <p class="validUntilDate">{{ formatDate(expiryDate) }}</p>
        </div>
        <div class="steps">
          <h3 class="discountTitle">{{ $t("COUPON_TITLE") }}</h3>
          <div class="coupon" v-for="coupon in coupons">
            <v-divider :class="{secondary: couponActive(coupon)}"/>
            <div v-if="coupon === nextCoupon" class="missingNext">
              <p v-html="$t('COUPON_VALUE_MISSING').replace('{value}', formatPrice((coupon.minimumValue - subtotal)))"></p>
              <svg viewBox="0 0 285.2 246.99">
                <polygon class="secondary--text caret" style="stroke-miterlimit: 10;"
                         points="142.6 245.99 0.87 0.5 284.33 0.5 142.6 245.99"/>
              </svg>
            </div>
            <div class="couponInfo">
              <div :class="{couponDiscount: true, secondary: couponActive(coupon)}">
                <span v-if="coupon.type === 'VALUE'">-{{ formatPriceShort(coupon.discount) }}</span>
                <span v-if="coupon.type === 'PERCENTAGE'">-{{ coupon.discount }}%</span>
                <v-icon v-if="coupon.type === 'FREE_SHIPPING'" size="30px">local_shipping</v-icon>
              </div>
              <p class="condition"
                 v-html="$t('COUPON_CONDITION').replace('{value}', formatPrice(coupon.minimumValue))"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p v-if="hasNextCoupon" class="missing"
       v-html="$t('COUPON_MISSING_NEXT').replace('{value}', formatPrice(nextCoupon.minimumValue - subtotal))"></p>
    <p v-else class="missing">
      <v-icon size="16px">check</v-icon>
      {{ $t('COUPON_ALL_ACTIVATED') }}
    </p>
  </div>
</div>

